import { get, post } from "@/libs/http";
import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { createApiQuery } from "@/hooks/use-api-query";
import { SendCodeReq, SendCodeRes } from "@/types/api/user-auth/send-code.d";
import { LoginWithCodeReq, LoginWithCodeRes } from "@/types/api/user-auth/login-with-code.d";
import { LoginWithPasswordReq, LoginWithPasswordRes } from "@/types/api/user-auth/login-with-password.d";
import { LoginTypeRes } from "@/types/api/user-auth/login-type.d";

// 登录类型枚举
export enum LoginType {
  // 第三方账号登录 (从10开始)
  LOGIN_TYPE_GOOGLE = 10,        // Google账号登录
  LOGIN_TYPE_FACEBOOK = 11,      // Facebook账号登录
  LOGIN_TYPE_TELEGRAM = 12,      // Telegram登录

  // 钱包登录类型 (从20开始)
  LOGIN_TYPE_METAMASK = 20,         // Metamask钱包登录
  LOGIN_TYPE_OKX_WALLET = 21,       // OKX Wallet登录
  LOGIN_TYPE_COINBASE_WALLET = 22,  // Coinbase Wallet登录
  LOGIN_TYPE_RABBY_WALLET = 23,     // Rabby Wallet登录
  LOGIN_TYPE_TRUST_WALLET = 24,     // Trust Wallet登录
  LOGIN_TYPE_PHANTOM = 25,          // Phantom钱包登录
  LOGIN_TYPE_RAINBOWKIT = 26,       // Rainbow Kit登录
}

export enum LoginWay {
  LOGIN_WAY_PHONE = 1,
  LOGIN_WAY_EMAIL = 2,
}

export enum IsNew {
  IS_NEW_YES = 1,
  IS_NEW_NO = 2,
}

export enum IsPassword {
  IS_PASSWORD_YES = 1,
  IS_PASSWORD_NO = 2,
}


// 修改 API 函数以符合 createApiMutationHook 和 createApiQueryHook 的格式
export const getLoginType = () => get<LoginTypeRes>('/user/auth/v1/loginType');

export const sendCode = ({ params }: { params: SendCodeReq; }) => post<SendCodeRes>('/user/auth/v1/sendCode', params);

export const loginWithCode = ({ params }: { params: LoginWithCodeReq; }) => post<LoginWithCodeRes>('/user/auth/v1/loginWithCode', params);

export const loginWithPassword = ({ params }: { params: LoginWithPasswordReq; }) => post<LoginWithPasswordRes>('/user/auth/v1/loginWithPassword', params);

// 创建 React Query hooks
export const useGetLoginType = createApiQuery(getLoginType, () => ['loginType']);

export const useSendCode = createApiMutationHook(sendCode);

export const useLoginWithCode = createApiMutationHook(loginWithCode);

export const useLoginWithPassword = createApiMutationHook(loginWithPassword);
